<template>
    <button
        class="bg-gray-200 rounded-md cursor-pointer disabled:cursor-not-allowed"
        :class="{
            'opacity-50': disabled,
            'p-0.5': size === 'sm',
            'p-1': size === 'default',
        }"
        :aria-label="computedModelValue ? falseText : trueText"
        :disabled="disabled"
        @click="computedModelValue = !computedModelValue"
    >
        <div class="grid grid-cols-2 relative overflow-hidden">
            <div class="absolute top-0 left-0 w-1/2 h-full rounded-md bg-primary-800 transition-transform duration-300" :class="computedModelValue ? '' : 'transform translate-x-full'" aria-hidden="true"></div>
            <div
                class="relative h-full border-0 transition-colors duration-300 focus:outline-none font-medium"
                :class="{
                    'text-white': computedModelValue,
                    'px-2 py-1 text-sm': size === 'sm',
                    'px-4 py-2': size === 'default',
                }"
            >
                {{ trueText }}
            </div>
            <div
                class="relative h-full border-0 transition-colors duration-300 focus:outline-none font-medium"
                :class="{
                    'text-white': !computedModelValue,
                    'px-2 py-1 text-sm': size === 'sm',
                    'px-4 py-2': size === 'default',
                }"
            >
                {{ falseText }}
            </div>
        </div>
    </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

type AcceptedModelValue = boolean | number | string;

interface Props {
    modelValue: AcceptedModelValue;
    trueText: string;
    falseText: string;
    trueValue: AcceptedModelValue;
    falseValue: AcceptedModelValue;
    disabled?: boolean;
    size?: 'default' | 'sm';
}

const props = withDefaults(defineProps<Props>(), {
    disabled: undefined,
    size: 'default',
});
const emit = defineEmits<{
    'update:modelValue': [value: AcceptedModelValue];
}>();

const computedModelValue = computed({
    get() {
        return props.modelValue === props.trueValue;
    },
    set(newValue: boolean) {
        const value = newValue ? props.trueValue : props.falseValue;

        emit('update:modelValue', value);
    },
});
</script>
